import { startOfDay, startOfMonth, startOfYear } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

const SP_TZ = 'America/Sao_Paulo';

export const getDateTimezone = (date?: Date | string | number, startOf?: 'day' | 'month' | 'year'): Date => {
  const jsDate = date ? new Date(date) : new Date();
  const zonedDate = toZonedTime(jsDate, SP_TZ);

  if (startOf === 'day') return startOfDay(zonedDate);
  if (startOf === 'month') return startOfMonth(zonedDate);
  if (startOf === 'year') return startOfYear(zonedDate);

  return zonedDate;
};
